<ng-template pTemplate="header">
  <span class="text-xl font-bold">Gestisci seriali</span>
</ng-template>

<div class="tbl max-w-full">
  <p-table
    [value]="items.controls"
    [scrollable]="true"
    scrollHeight="60vh"
    [loading]="loading">
    <ng-template pTemplate="caption">
      <ng-container *ngIf="selectedWarehouse"> Magazzino selezionato: {{ selectedWarehouse.name }} </ng-container>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Prodotto</th>
        <th>Aggiungi nuovi seriali</th>
        <th>Q.tà</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-item>
      <tr [formGroup]="item">
        <td>
          <div class="flex flex-column align-items-start justify-content-center gap-1">
            <span class="font-bold"
              >{{ item.get('name')?.value }} -
              {{ item.get('brand')?.value || 'Brand non specificato' }}</span
            >
            <small class="grey-text">{{ item.get('code_internal')?.value || 'Non specificato' }}</small>
            <small
              class="grey-text"
              *ngIf="item.get('agreement_code')?.value"
              >Codice commessa: {{ item.get('agreement_code')?.value }}</small
            >
            <small
              class="grey-text"
              *ngIf="item.get('integration_code')?.value"
              >Codice integrazione: {{ item.get('integration_code')?.value }}</small
            >
          </div>
        </td>
        <td>
          <h3>Aggiungi nuovi seriali</h3>
          <div class="p-inputgroup">
            <ng-container *ngIf="!item.value.required_asset_code">
              <input
                pInputText
                type="text"
                class="w-full"
                formControlName="tmp_serial"
                placeholder="Inserisci il serial number..."
                (keydown)="addSerialKeyDown($event, item)" />
            </ng-container>
            <ng-container *ngIf="item.value.required_asset_code">
              <input
                #serial
                pInputText
                type="text"
                class="w-full"
                formControlName="tmp_serial"
                placeholder="Inserisci il serial number..."
                (keydown)="goToAssetCode($event, assetCode)" />
              <input
                #assetCode
                pInputText
                type="text"
                class="w-full"
                formControlName="tmp_asset_code"
                placeholder="Inserisci l'asset code..."
                (keydown)="addSerialKeyDown($event, item, serial)" />
            </ng-container>

            <button
              type="button"
              pButton
              icon="pi pi-plus"
              styleClass="p-button-warn"
              (click)="addSerial(item)"
              [disabled]="item.get('serial_numbers')?.value.length >= item.get('qty')?.value"></button>
            <button
              type="button"
              pButton
              icon="pi pi-bars"
              styleClass="p-button-warn"
              [pTooltip]="'Seleziona un asset dal magazzino selezionato'"
              [disabled]="item.get('serial_numbers')?.value.length >= item.get('qty')?.value"
              (click)="selectSerial(item)"></button>
            <button
              type="button"
              pButton
              icon="pi pi-upload"
              styleClass="p-button-warn"
              [pTooltip]="'Importa gli asset da un CSV'"
              [disabled]="item.get('serial_numbers')?.value.length >= item.get('qty')?.value"
              (click)="selectedItem = item; op.toggle($event)"></button>
            <p-overlayPanel
              #op
              [dismissable]="false"
              [showCloseIcon]="true">
              <div
                class="flex flex-column align-items-stretch justify-content-start gap-2"
                *ngIf="selectedItem"
                [formGroup]="selectedItem">
                <textarea
                  rows="7"
                  cols="80"
                  pInputTextarea
                  formControlName="tmp_serial_textarea"></textarea>
                <button
                  type="button"
                  pButton
                  class="align-self-end"
                  icon="pi pi-save"
                  styleClass="p-button-warn"
                  [pTooltip]="'Importa serial numbers'"
                  (click)="addMultipleSerial(op)"></button>
              </div>
            </p-overlayPanel>
          </div>
        </td>
        <td>
          {{ item.get('serial_numbers')?.value.length || 0 }}/{{ item.get('qty')?.value }}
        </td>
      </tr>
      <tr *ngIf="item.get('serial_numbers')?.controls.length > 0">
        <td colspan="3">
          <div class="flex flex-row flex-wrap gap-2">
            <ng-container
              *ngFor="let n of item.get('serial_numbers')?.controls; let indexSerial = index">
              <p-chip
                [removable]="true"
                (onRemove)="removeSerial(indexSerial, item.get('serial_numbers')!)">
                <div class="p-1">
                  SN: {{ n.value.code }}
                  <small
                    class="block"
                    *ngIf="n.value.asset_code">
                    AssetCode: {{ n.value.asset_code }}
                  </small>
                </div>
              </p-chip>
            </ng-container>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="3"
          class="text-center py-2">
          Nessun prodotto oggetto di staging in questa consegna.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      icon="pi pi-times"
      (click)="close()"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      [loading]="saving"
      (click)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
